// src/components/AdminSettings/modals/EditProfileModal.tsx
import React, { useState } from 'react';
import { Modal, ModalSection } from '../../ui/Modal';
import { TextInput } from '../../ui/TextInput';
import { FormSelect } from '../../ui/FormSelect';
import { TIMEZONE_SELECT_OPTIONS } from '../constants';
import type { EditProfileModalProps } from '../types';

export const EditProfileModal: React.FC<EditProfileModalProps> = ({
  isOpen,
  onClose,
  form,
  onFormChange,
  onSave,
}) => {
  const [timezoneSearch, setTimezoneSearch] = useState('');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      header={{ title: 'Edit Profile' }}
      footer={{
        primaryAction: { label: 'Save', onClick: onSave },
        secondaryAction: { label: 'Cancel', onClick: onClose },
      }}
    >
      <ModalSection spacing="normal">
        <TextInput
          label="Full Name"
          value={form.full_name}
          onChange={(v) => onFormChange({ ...form, full_name: v })}
          placeholder="Your full name"
          variant="default"
        />
        <div style={{ marginTop: 16 }}>
          <TextInput
            label="Display Name"
            value={form.display_name}
            onChange={(v) => onFormChange({ ...form, display_name: v })}
            placeholder="How you want to be called"
            variant="default"
          />
        </div>
        <div style={{ marginTop: 16 }}>
          <TextInput
            label="Phone"
            value={form.phone}
            onChange={(v) => onFormChange({ ...form, phone: v })}
            placeholder="+1 (555) 123-4567"
            type="tel"
            variant="default"
          />
        </div>
        <div style={{ marginTop: 16 }}>
          <FormSelect
            label="Timezone"
            value={timezoneSearch}
            onChange={setTimezoneSearch}
            options={TIMEZONE_SELECT_OPTIONS}
            selectedOption={TIMEZONE_SELECT_OPTIONS.find(t => t.value === form.timezone) || null}
            onSelect={(opt) => {
              onFormChange({ ...form, timezone: opt.value });
              setTimezoneSearch('');
            }}
            placeholder="Select timezone..."
            variant="default"
          />
        </div>
      </ModalSection>
    </Modal>
  );
};

export default EditProfileModal;
